import { Alert, Backdrop, Box, CircularProgress } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import PasswordChange from "./password_change";

function UserPasswordChange() {
    const [alertMessage, setAlertMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const stateChange = (load) => {
        setIsLoading(load);
    }

    const errorChange = (msg) => {
        if (msg) setAlertMessage(msg);
        else setAlertMessage(false);
    }

    const initData = async () => {

    }

    return (
        <MenuFrame onInit={initData} login={true} title={"Password"}>
            {alertMessage === null ? "" :
                <Box sx={{ mt: 2 }}>
                    <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                </Box>
            }
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ mt: 1 }}>
                <PasswordChange onFinish={errorChange} onStateChange={stateChange} />
            </Box>
        </MenuFrame>
    );
}

export default UserPasswordChange;
